var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCannedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.63158 1.81579C3.63158 2.81862 2.81862 3.63158 1.81579 3.63158C0.812957 3.63158 0 2.81862 0 1.81579C0 0.812957 0.812957 0 1.81579 0C2.81862 0 3.63158 0.812957 3.63158 1.81579ZM3.63158 10.2895C3.63158 11.2923 2.81862 12.1053 1.81579 12.1053C0.812957 12.1053 0 11.2923 0 10.2895C0 9.28664 0.812957 8.47368 1.81579 8.47368C2.81862 8.47368 3.63158 9.28664 3.63158 10.2895ZM1.81579 20.5789C2.81862 20.5789 3.63158 19.766 3.63158 18.7632C3.63158 17.7603 2.81862 16.9474 1.81579 16.9474C0.812957 16.9474 0 17.7603 0 18.7632C0 19.766 0.812957 20.5789 1.81579 20.5789ZM7.55263 8.47368C6.7242 8.47368 6.05263 9.14526 6.05263 9.97369V10.6053C6.05263 11.4337 6.7242 12.1053 7.55263 12.1053H21.5C22.3284 12.1053 23 11.4337 23 10.6053V9.97368C23 9.14526 22.3284 8.47368 21.5 8.47368H7.55263ZM6.05263 1.5C6.05263 0.671574 6.7242 0 7.55263 0H21.5C22.3284 0 23 0.671573 23 1.5V2.13158C23 2.96001 22.3284 3.63158 21.5 3.63158H7.55263C6.7242 3.63158 6.05263 2.96001 6.05263 2.13158V1.5ZM7.55263 16.9474C6.7242 16.9474 6.05263 17.6189 6.05263 18.4474V19.0789C6.05263 19.9074 6.7242 20.5789 7.55263 20.5789H21.5C22.3284 20.5789 23 19.9074 23 19.0789V18.4474C23 17.6189 22.3284 16.9474 21.5 16.9474H7.55263Z",
    fill: "url(#paint0_linear_600_830)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_600_830",
    x1: 0,
    y1: 10.2895,
    x2: 23,
    y2: 10.2895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3153C7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCannedIcon);
export default __webpack_public_path__ + "static/media/canned_icon.651e77190b72068077a21ef3a8186976.svg";
export { ForwardRef as ReactComponent };